import React, { useEffect, useState } from "react";
import "./GivingHeader.scss";
import EmoryUniversityLogo from "../assets/EmoryUniversityLogo.svg";
import EmoryHealthcareLogo from "../assets/EmoryHealthcareLogo.svg";
import EmoryWinshipLogo from "../assets/EmoryWinshipLogo.svg";
import EmoryShieldLogo from "../assets/EmoryShieldLogo.svg";
import logos from "../assets/logos.json";
import { useAppContext } from "../hooks/useAppContext";

const components = {
  EmoryUniversityLogo: EmoryUniversityLogo,
  EmoryHealthcareLogo: EmoryHealthcareLogo,
  EmoryWinshipLogo: EmoryWinshipLogo,
};

const camelCaseToSnakeCase = (str) =>
  str.replace(/[A-Z]/g, (letter, index) => {
    return index == 0 ? letter.toLowerCase() : "_" + letter.toLowerCase();
  });

function getLogoComponent(name) {
  const NamedSvgLogo = components[name];
  return <NamedSvgLogo id={camelCaseToSnakeCase(name)} />;
}

const GivingHeader = (props) => {
  const { children, type } = props;
  const { items } = useAppContext();
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    if (items.length && items[0].attributes?.aid) {
      const fundAid = items[0].attributes.aid;
      if (
        logos.hasOwnProperty(fundAid) &&
        components.hasOwnProperty(logos[fundAid])
      ) {
        setLogo(getLogoComponent(logos[fundAid]));
      }
    }
  }, [items]);

  if (logo) {
    return (
      <div className="giving-header giving-header--custom-branded">{logo}</div>
    );
  }

  return (
    <>
      {(type == "dual-branded" && (
        <div className="giving-header giving-header--dual-branded hidden-sm">
          <EmoryUniversityLogo id="emory_university_logo" width="284" />
          <div className="giving-header__separator header__separator--dual-branded"></div>
          <EmoryHealthcareLogo id="emory_healthcare_logo" width="184" />
        </div>
      )) ||
        null}
      {type == "shield" && (
        <div className="giving-header givin-header--shield">
          <div className="giving-header__separator header__separator--shield"></div>
          <EmoryShieldLogo id="emory_shield_logo" width="105" />
          <div className="giving-header__separator header__separator--shield"></div>
        </div>
      )}
    </>
  );
};

export default GivingHeader;
